// u16 D7 / Q2 = A: the CMS colour theme, per device (localStorage). Light is the default; the choice
// lives in Profile. public/theme-init.js applies the same rule before first paint.
export type ThemePref = 'light' | 'dark' | 'system';

export const THEME_KEY = 'ep-theme';
export const THEME_PREFS: readonly ThemePref[] = ['light', 'dark', 'system'];

const DARK_QUERY = '(prefers-color-scheme: dark)';

export function readThemePref(): ThemePref {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === 'dark' || v === 'system' ? v : 'light';
  } catch {
    return 'light';
  }
}

const systemDark = () =>
  typeof window.matchMedia === 'function' && window.matchMedia(DARK_QUERY).matches;

export function applyTheme(pref: ThemePref) {
  const dark = pref === 'dark' || (pref === 'system' && systemDark());
  if (dark) document.documentElement.setAttribute('data-theme', 'dark');
  else document.documentElement.removeAttribute('data-theme');
}

export function saveThemePref(pref: ThemePref) {
  try {
    if (pref === 'light') localStorage.removeItem(THEME_KEY);
    else localStorage.setItem(THEME_KEY, pref);
  } catch {
    // Storage blocked: the choice still applies for this visit.
  }
  applyTheme(pref);
}

/** Keeps `system` in step with the OS setting while the app is open. */
export function watchSystemTheme() {
  if (typeof window.matchMedia !== 'function') return;
  window
    .matchMedia(DARK_QUERY)
    .addEventListener?.('change', () => readThemePref() === 'system' && applyTheme('system'));
}
